import { styled } from '../jss-style';
import tableStyle from './table';

const useTableStyle = styled(tableStyle, 'table');
export { tableStyle, useTableStyle };
export default useTableStyle;
